const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

// Prefix match on a word boundary so "truffle" also matches "truffles".
const mentions = (text, keyword) =>
  new RegExp(`\\b${escapeRegExp(keyword)}`, "i").test(text)

// The first visible ebook with a keyword mentioned in any of the texts.
export const promotedEbook = (ebooks, texts) => {
  const content = texts.filter(Boolean).join(" ")
  return ebooks.find(
    (ebook) =>
      ebook.status !== "hidden" &&
      ebook.keywords.some((keyword) => mentions(content, keyword))
  )
}

export const ebookPath = (ebook) => `/ebooks/${ebook.slug}/`

export const isPurchasable = (ebook) =>
  ["presale", "available"].includes(ebook.status) && Boolean(ebook.checkoutUrl)

// The price a buyer pays right now: early bird during presale, full otherwise.
export const currentPrice = (ebook) =>
  ebook.status === "presale" && ebook.earlyBirdPrice
    ? ebook.earlyBirdPrice
    : ebook.price

export const formatPrice = (amount, currency) =>
  `${currency === "AUD" ? "A$" : `${currency} `}${amount}`
